import fetchOverride from '@/api/fetch-override';
import { useXpanseAuth } from '@/hooks/useXpanseAuthentication';
import { Configuration } from '@xpanse/organization-service-client';

interface UseApiConfigOptions {
  /** When true, uses the base path as-is without appending the tenant alias. */
  excludeTenantAlias?: boolean;
}

export const useApiConfig = (serviceBasePath: string, options?: UseApiConfigOptions) => {
  const { user = {} } = useXpanseAuth();

  const tenantAlias = user?.['https://xpanse.com/claims/auth/context']?.tenantAlias;

  const basePath = options?.excludeTenantAlias
    ? serviceBasePath
    : `${serviceBasePath}/${tenantAlias}`;

  return new Configuration({
    basePath,
    fetchApi: fetchOverride,
  });
};
